// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Vkwiw","label":"Section_label__3rNXf","contentWrap":"Section_contentWrap__S4_jj","footer":"Section_footer__1AnfK","footerInner":"Section_footerInner__3Vk8a"};